import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { logout } from "../actions/auth";

export default function Logout() {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (auth.token) {
      dispatch(logout());
    }
    window.location.assign("/");
  }, [auth]);

  return null;
}
